import { CUSTOM_EVENT_USER_STATUS_CHANGED } from "@icebergeradmin/common";
import axios from "./axios.callcenter";
import { TLiveAgents } from "@/models/call.center.model";

export const getLiveAgents = async (callCenterId?: number): Promise<TLiveAgents> => {
  const params = callCenterId ? { callCenterId } : {};
  const response = await axios.get("/users", { params });
  return response.data;
};

export const getMyCurrentCallCenterStatus = async (): Promise<number> => {
  const response = await axios.get("/users/me");
  return response.data.status;
};

export const notifyAgentStatusChanged = async (newStatus: number) => {
  await axios.post("/webhooks", {
    event: CUSTOM_EVENT_USER_STATUS_CHANGED,
    payload: {
      object: {
        status: newStatus,
      },
    },
  });
};
